import React from 'react';
import { Input, Select } from './UI';
import {
  CST_COM_DIFERIMENTO, CST_COM_FCP, CST_COM_REDUCAO, MODALIDADES_BC_ST, MOTIVOS_DESONERACAO,
  codigoComSt,
} from '../utils/icmsSt';

// Campos de redução, diferimento, FCP, ICMS-ST e desoneração (F0c/F0d), só os que o
// código de ICMS usa. No cadastro do produto o escritório edita (editavel); na emissão
// o operador só vê o que veio do cadastro e informa o valor desonerado do item.

const caixa = {
  padding: '8px 10px', fontSize: '13px', borderRadius: '6px', border: '1px solid #ddd',
  background: '#f5f5f5', color: '#555', minHeight: '17px',
};

function Campo({ label, campo, valores, editavel, onChange, sufixo = '' }) {
  const v = valores?.[campo];
  return editavel ? (
    <Input label={label} type="number" step="0.0001" value={v ?? ''}
      onChange={e => onChange(campo, e.target.value === '' ? null : e.target.value)} />
  ) : (
    <div style={{ marginBottom: '10px' }} title="Definido no cadastro do produto (escritório)">
      <label style={{ display: 'block', fontSize: '12px', color: '#555', marginBottom: '4px' }}>{label}</label>
      <div style={caixa}>{v === null || v === undefined || v === '' ? '—' : `${v}${sufixo}`}</div>
    </div>
  );
}

export default function CamposIcmsSt({ regime, valores, editavel, onChange, valorDesonerado }) {
  const cst = String(valores?.cst_icms || '').trim();
  const simples = [1, 4].includes(Number(regime));
  const reducao = !simples && CST_COM_REDUCAO.includes(cst);
  const diferimento = !simples && CST_COM_DIFERIMENTO.includes(cst);
  const fcp = !simples && CST_COM_FCP.includes(cst);
  const st = codigoComSt(regime, cst);
  const motivos = simples ? [] : (MOTIVOS_DESONERACAO[cst] || []);
  if (!reducao && !diferimento && !fcp && !st && !motivos.length) return null;
  const props = { valores, editavel, onChange };
  const modalidade = String(valores?.modalidade_bc_st || '');

  return (
    <div style={{ border: '1px dashed #ccc', borderRadius: '8px', padding: '10px 12px', margin: '8px 0' }}>
      <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
        {editavel
          ? 'Dados fiscais do produto (definidos pelo escritório; a emissão usa estes valores).'
          : 'Dados fiscais do cadastro do produto — só o escritório altera.'}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 16px' }}>
        {reducao && <Campo label="Redução da base do ICMS (%)" campo="reducao_bc_icms" sufixo="%" {...props} />}
        {diferimento && <Campo label="Diferimento (%)" campo="diferimento_icms" sufixo="%" {...props} />}
        {fcp && <Campo label="FCP (%)" campo="aliquota_fcp" sufixo="%" {...props} />}
      </div>
      {st && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 16px' }}>
          {editavel ? (
            <Select label="Base da ST" value={modalidade} onChange={e => onChange('modalidade_bc_st', e.target.value || null)}>
              <option value="">— Sem ST{cst === '90' || cst === '900' ? '' : ' (obrigatória)'} —</option>
              {MODALIDADES_BC_ST.map(m => <option key={m.codigo} value={m.codigo}>{m.codigo} - {m.descricao}</option>)}
            </Select>
          ) : (
            <div style={{ marginBottom: '10px' }}>
              <label style={{ display: 'block', fontSize: '12px', color: '#555', marginBottom: '4px' }}>Base da ST</label>
              <div style={caixa}>{MODALIDADES_BC_ST.find(m => m.codigo === modalidade)?.descricao || (modalidade || '—')}</div>
            </div>
          )}
          {modalidade === '4' && <Campo label="MVA da ST (%)" campo="mva_st" sufixo="%" {...props} />}
          <Campo label="Alíquota interna da ST (%)" campo="aliquota_icms_st" sufixo="%" {...props} />
          <Campo label="Redução da base da ST (%)" campo="reducao_bc_st" sufixo="%" {...props} />
          <Campo label="FCP-ST (%)" campo="aliquota_fcp_st" sufixo="%" {...props} />
        </div>
      )}
      {motivos.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 16px' }}>
          {editavel ? (
            <>
              <Select label="Motivo da desoneração" value={valores?.motivo_desoneracao || ''}
                onChange={e => onChange('motivo_desoneracao', e.target.value || null)}>
                <option value="">— Sem desoneração —</option>
                {motivos.map(m => <option key={m} value={m}>{m}</option>)}
              </Select>
              <Select label="Desoneração deduz do total?" value={valores?.deduz_desoneracao || ''}
                onChange={e => onChange('deduz_desoneracao', e.target.value || null)}>
                <option value="">Não informado</option>
                <option value="0">0 - Não deduz</option>
                <option value="1">1 - Deduz do valor da nota</option>
              </Select>
            </>
          ) : (
            <div style={{ marginBottom: '10px' }}>
              <label style={{ display: 'block', fontSize: '12px', color: '#555', marginBottom: '4px' }}>Motivo da desoneração</label>
              <div style={caixa}>{valores?.motivo_desoneracao || '—'}{valores?.deduz_desoneracao === '1' ? ' (deduz do total)' : ''}</div>
            </div>
          )}
          {valorDesonerado && valores?.motivo_desoneracao && valorDesonerado}
        </div>
      )}
    </div>
  );
}
